import { ChangeDetectionStrategy, Component, input, model, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TimezoneHelper } from '@shared/helpers';
import { cloneDeep, isArray, isEqual } from 'lodash-es';
import { DatePickerModule } from 'primeng/datepicker';
import { FormLabelComponent } from '../form-label/form-label.component';

@Component({
    selector: 'datepicker',
    standalone: true,
    imports: [TranslateModule, DatePickerModule, FormsModule, FormLabelComponent],
    templateUrl: './datepicker.component.html',
    styleUrl: './datepicker.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DatepickerComponent {
    id = input.required<string>();
    value = model.required<(Date | null)[] | Date | null | undefined>();

    label = input<string>('');
    tooltipText = input<string>('');
    required = input<boolean>(false);
    invalid = input<boolean>(false);

    maxDate = input<Date | undefined>(undefined);
    minDate = input<Date | undefined>(undefined);
    maxDateToday = input<boolean>(false); // use if the max date should be today
    maxDateTodayUTC = input<boolean>(false); // use if the max date should be today in UTC

    placeholder = input<string>('uiKit.form.datepicker.placeholder');
    disabled = input<boolean>(false);

    size = input<'small' | 'large'>('large');

    selectionMode = input<'range' | 'single' | 'multiple'>('range');
    showClear = input<boolean>(true);
    showButtonBar = input<boolean>(true);
    readonlyInput = input<boolean>(true);

    valueChange = output<(Date | null)[] | Date | null | undefined>();

    readonly endOfCurrentDay = TimezoneHelper.datePickerEndOfCurrentDate();
    readonly endOfCurrentDayUTC = TimezoneHelper.datePickerEndOfCurrentDateUTC();
    private previousValue: (Date | null)[] | Date | null | undefined = undefined;

    onClear(): void {
        this.previousValue = null;
        this.valueChange.emit(null);
    }

    onOpen(): void {
        this.previousValue = cloneDeep(this.value());
    }

    onClose(): void {
        const currentValue = this.value();

        if (
            currentValue &&
            isArray(currentValue) &&
            currentValue[0] !== null &&
            currentValue[1] === null &&
            currentValue[0] !== undefined
        ) {
            this.value.set([currentValue[0], cloneDeep(currentValue[0])]);
        }

        if (!isEqual(currentValue, this.previousValue)) {
            this.valueChange.emit(this.value());
            this.previousValue = cloneDeep(this.value());
        }
    }
}
